export default __webpack_public_path__ + "static/media/icon-slider-arrow.385f662f.svg";